import { Profile } from '../types';


export const fetchProfileById = async (id: string): Promise<Profile> => {
  try {
    const response = await fetch(`/api/profiles/${id}`);
    
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Profile not found');
      }
      throw new Error(`Failed to fetch profile: ${response.statusText}`);
    }
    
    const profile = await response.json();
    return profile;
  } catch (error) {
    console.error('Error fetching profile:', error);
    throw error;
  }
};
